import React from 'react';
import { navigateToAngular } from '../../services/navigate';

export interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="breadcrumb">
      <ol className="breadcrumb">
        {items.map((item, i) => {
          const isLast = i === items.length - 1;
          return (
            <li key={i} className={isLast ? 'active' : undefined}>
              {!isLast && item.href ? (
                <a href="#" onClick={e => { e.preventDefault(); navigateToAngular(item.href!); }}>
                  {item.label}
                </a>
              ) : (
                item.label
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
